import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api, { TOKEN_KEY } from "./api";

const USER_KEY = "formlyze_admin_user";

export const loginAdmin = createAsyncThunk(
    "auth/loginAdmin",
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await api.post("/admin/login", credentials);
            return response.data;
        } catch (error) {
            if (error.response) return rejectWithValue(error.response.data);
            throw error;
        }
    }
);

const authSlice = createSlice({
    name: "auth",
    initialState: {
        token: localStorage.getItem(TOKEN_KEY) || null,
        admin: (() => {
            try {
                return JSON.parse(localStorage.getItem(USER_KEY));
            } catch {
                return null;
            }
        })(),
        loginStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
        error: null,
    },
    reducers: {
        logout(state) {
            state.token = null;
            state.admin = null;
            state.loginStatus = "idle";
            state.error = null;
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(USER_KEY);
        },
        clearAuthError(state) {
            state.error = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(loginAdmin.pending, (state) => {
                state.loginStatus = "loading";
                state.error = null;
            })
            .addCase(loginAdmin.fulfilled, (state, action) => {
                state.loginStatus = "success";
                state.token = action.payload.token;
                state.admin = action.payload.data.admin;
                localStorage.setItem(TOKEN_KEY, action.payload.token);
                localStorage.setItem(USER_KEY, JSON.stringify(action.payload.data.admin));
            })
            .addCase(loginAdmin.rejected, (state, action) => {
                state.loginStatus = "failed";
                state.error = action.payload?.message || "Login failed. Please try again.";
            });
    },
});

export const { logout, clearAuthError } = authSlice.actions;
export default authSlice.reducer;
